import { computed, inject } from '@angular/core';
import { AiAgentContextSource } from '@softapps/ai-agent';
import { translator } from '@softline/ui-core';
import { SalesStatisticsAgentBridge } from './sales-statistics-agent.bridge';

/**
 * Reports the dashboard's visible filters to the agent while the page is open.
 * Must run in an injection context (`provideAiAgentContextSource`).
 */
export function salesStatisticsContextSource(): AiAgentContextSource {
  const bridge = inject(SalesStatisticsAgentBridge);
  const title = translator()('#SALES_STATISTICS.MODULE_TITLE');

  return {
    id: 'sales-statistics',
    label: computed(() => String(title())),
    entry: computed(() => {
      const snapshot = bridge.snapshot();
      if (!snapshot) return null;
      return {
        description: 'Umsatzstatistik-Dashboard (sichtbare Filter)',
        value: JSON.stringify(snapshot),
      };
    }),
  };
}
